<template>
    <v-container >
        <v-dialog v-model="dialogVisible" persistent >
            <v-card>
                <v-toolbar dense>
                    <v-toolbar-title> {{label}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down">
                        <v-btn text @click="addAll">Asignar Todo</v-btn>
                        <v-btn text @click="removeAll">DesAsignar Todo</v-btn>
                        <v-btn fab text @click="dialogVisible =false" ><v-icon>check_circle_outline</v-icon></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container fluid>
                    <v-layout wrap justify-space-around>
                        <v-flex sm12 lg5>
                            <v-card>
                                <v-card-title >
                                    <h2>Seleccionados</h2>
                                    <v-spacer></v-spacer>
                                    <v-text-field clearable
                                        v-model="search1"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table 
                                    :headers="headersSeleccionados"
                                    :items="workingSelectedItems"
                                    :items-per-page.sync="options.itemsPerPage"
                                    
                                    :search="search1"
                                    v-model="selectedRow"
                                    :loading="loading"                    
                                >
                                    <template v-slot:no-data>
                                        <v-alert :value="true" color="grey" icon="warning">
                                            No hay items asignados
                                        </v-alert>
                                    </template>

                                    <template v-slot:item="{ item }">
                                    <tr>
                                        <template v-for="header in headers">
                                            <td class="text-xs-left">{{ item[header.value] }}</td>
                                        </template>

                                        <td class="text-xs-left" v-if="enabled">                
                                            <v-icon small class="mr-2" @click="remove(item)" >arrow_right</v-icon>                            
                                        </td>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>

                        <v-flex sm12 lg5 >
                            <v-card>
                                <v-card-title>
                                    <h2>Disponibles &nbsp;</h2>
                                    <v-spacer></v-spacer>
                                    <v-text-field clearable
                                        v-model="search2"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>
                    
                                <v-data-table 
                                    :headers="headersDisponibles"
                                    :items="itemsDisponibles"
                                    
                                    :items-per-page.sync="options.itemsPerPage"
                                    
                                    :options.sync ="options"
                                    v-model="selectedRow"
                                    :loading="loading"
                                    :search="search2"
                                >
                                    <template v-slot:no-data>
                                        <v-alert :value="true" color="grey" icon="warning">
                                            No se encontraron datos
                                        </v-alert>
                                    </template>

                                    <template v-slot:item="{ item }">
                                    <tr>
                                        <td class="text-xs-left">                
                                            <v-icon small class="mr-2" @click="add(item)" >arrow_left</v-icon>    
                                        </td>
                                         <template v-for="header in headers">
                                            <td class="text-xs-left">{{ item[header.value] }}</td>
                                        </template>

                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            
            </v-card>
        </v-dialog>

        <v-card>
            <v-toolbar dense>
                <v-toolbar-title> {{label}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <v-btn top small fab @click="dialogVisible = true" v-if="enabled"><v-icon>edit</v-icon></v-btn>                    
                </v-toolbar-items>
            </v-toolbar>
            <v-container  >
                <v-layout wrap>
                    <v-flex sm12 grow >
                        <v-card>
                            <!-- <v-card-title >
                                <h2>Asignados</h2>
                                <v-spacer></v-spacer>
                                <v-text-field clearable
                                    v-model="search1"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-card-title> -->

                            <v-data-table 
                                :headers="headers"
                                :items="workingSelectedItems"
                                :items-per-page.sync="options.itemsPerPage"
                                
                                v-model="selectedRow"
                                :loading="loading"                    
                            >
                                <template v-slot:no-data>
                                    <v-alert :value="true" color="grey" icon="warning">
                                        No hay items asignados
                                    </v-alert>
                                </template>

                                <template v-slot:item="{ item }">
                                <tr>
                                    <template v-for="header in headers">
                                        <td class="text-xs-left">{{ item[header.value] }}</td>
                                    </template>

                                </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
            
        </v-card>
    </v-container>
</template>


<style>
.double-list .list-group.list {
    overflow-y: auto;
    user-select: none;
}
.double-list .list-group.list.empty {
    background-color: #F3F2EE;
    border: 1px solid #ddd;
    border-radius: 4px;
}
.double-list .list-group.header {
    margin-bottom: 5px;
}
.double-list .list-group-item.input {
    padding: 0;
}
.double-list .list-group-item.input input {
    border: 0;
}
.double-list .list-group-item.input label {
    padding: 7px 15px;
}
.double-list .list-group-item.marked {
    background-color: #08C;
    color: white;
}
</style>


<script>

//import { http } from '@/axios'
import {
  //mapState,
  //mapGetters,
  mapMutations
  //mapActions
} from 'vuex'

export default {
  props: ['label','selectedItems', 'items', 'value', 'headers', 'enabled'],
  mounted: function () {
    
  },
  activated: function () {
    let selected = this.selectedValues
    if (selected.length > 0) {
      this.$emit('input', selected)
    }
  },
  deactivated: function () {
    this.$emit('input', [])
  },
  watch:{
    selectedItems:{
        handler(){            
            if(this.flag)
                return;
            
            this.workingSelectedItems = []

            if(this.items && this.selectedItems){
                for (let i = 0; i < this.selectedItems.length; i++) {
                    const selectedId = this.selectedItems[i];
                    // busco el item x su id en la lista completa
                    for (let j = 0; j < this.items.length; j++) {
                        const element = this.items[j];

                        if(element.id == selectedId)
                        {   
                            // lo agrego a la lista de items de trabajo                   
                            this.workingSelectedItems.push(element);
                        }
                    }                         
                }
            }
      }
    },   
    enabled:{
      handler(){
          if(this.enabled){
            // limpio la lista de trabajo
            
          }
      }
    }    
  },
  computed: {
    selectedValues: function () {
      return this.listItems.filter(function (item) {
        return item.selected
      }).map(function (item) {
        return item.value
      })
    },
    itemsCount: function () {
      return this.items.length
    },
    selectedCount: function () {
        if(this.value)
            return this.value.length
        else
            return 0
    },    
    headersSeleccionados(){
        var arr = []
        for (let index = 0; index < this.headers.length; index++) {
            const element = this.headers[index];
            arr.push(element)
        }
        arr.push({ text: 'Quitar', value: '', width: 20, sortable: false})

        return arr
    },
    headersDisponibles(){
        var arr = []
        arr.push({ text: 'Agregar', value: '', width: 20, sortable: false})

        for (let index = 0; index < this.headers.length; index++) {
            const element = this.headers[index];
            arr.push(element)
        }

        return arr
    },
    itemsDisponibles(){
        // los disponibles son todos menos los que estan seleccionados
        const list =  this.items.filter((e) => !this.workingSelectedItems.includes(e));
        return list;
    },    
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),

    addAll: function(){        
        while (this.itemsDisponibles.length > 0) {
            this.moveMarked(this.itemsDisponibles[0], true)
        }
    },
    removeAll: function(){
        while (this.workingSelectedItems.length > 0) {
            this.moveMarked(this.workingSelectedItems[0], false)
        }
    },
    moveMarked: function (e, addToSelected) {
      this.flag = true
      if(addToSelected){
        this.workingSelectedItems.push(e)
        this.selectedItems.push(e.id)        
      }
      else{
        this.workingSelectedItems.splice(this.workingSelectedItems.indexOf(e),1)
        this.selectedItems.splice(this.selectedItems.indexOf(e.id),1)
      }
      this.flag = false

      this.$emit('input', this.selectedItems)
    },
    add: function (e) {
      this.moveMarked(e, true)
    },
    remove: function (e) {
      this.moveMarked(e, false)
    },
  },
  data: function () {
    return {
      loading: false,
      dialogVisible: false,
      search1: '',
      search2: '',
      flag: false,
      workingSelectedItems:[], // guardo una copia de todos los items seleccionados
      listItems: [],
      listItemsByKey: {},
      filter: '',
      markStart: null,                 
      selectedRow: [],
      options: { // definición de paginación
        sortDesc:false,
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20,50]
      },
      totalItems: 0,
    }
  },
}
</script>